module.exports = __webpack_public_path__ + "img/collection-engagementRingsPlatinum@2x.5c03210.jpg";